import Vue from 'vue'
import VueRouter from 'vue-router'

import { login1, queryCurrentUser } from "@/http/index.js";
import { buildExternalRouteUrl, mapMobilePathToPc, mapPcPathToMobile } from "@/router/deviceRouteMap";
Vue.use(VueRouter)

// 解决 Vue 重复点击相同路由，出现 Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation 问题
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// keepAlive 页面是否需要缓存
// requireAuth 页面是否需要验证

// 路由
const routes = [
  {
    name: 'login',
    path: '/',
    alias: '/login',
    component: () => import('@/views/login.vue'),
    meta: {
      requireAuth: false,
      keepAlive: false,
      title: '登录',
      menuFlag: false,
    }
  },
  {
    name: 'home',
    path: '/home',
    alias: '/index',
    component: () => import('@/views/home.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    }
  },
  // 制度学习
  {
    path: '/systemLearn',
    component: () => import('@/views/systemLearn.vue'),
    meta: {
      requireAuth: true,
      keepAlive: true,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    },
    children: [
      {
        name: 'index',
        path: 'system',
        component: () => import('@/components/system/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },
      },
      // 浏览人员
      {
        name: 'readPerson',
        path: 'readPerson',
        component: () => import('@/components/system/readPerson.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },
      },
      // 目录
      {
        name: 'catalog',
        path: 'catalog',
        component: () => import('@/components/system/catalog.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },
      }
    ]
  },
  // 管理学习
  {
    path: '/managerLearn',
    component: () => import('@/views/managerLearn.vue'),
    meta: {
      requireAuth: true,
      keepAlive: true,
      title: '人才学院',
      topNavFlag: true,
      menuFlag: true,
    },
    children: [
      // 视频课程
      {
        name: 'managerLearn-videoList',
        path: 'videoList',
        component: () => import('@/components/videoList.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 视频观看记录
      {
        name: 'managerLearn-videoRecordList',
        path: 'videoRecordList',
        component: () => import('@/components/videoWatchRecord.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 课程课件
      {
        name: 'managerLearn-courseWare',
        path: 'courseWare',
        component: () => import('@/components/courseWare.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 相关资料
      {
        name: 'managerLearn-relateData',
        path: 'relateData',
        component: () => import('@/components/relateData.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      {
        name: 'managerLearn-videoBox',
        path: 'videoBox',
        component: () => import('@/components/videoPublic.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          topNavFlag: false,
          backBtn: false,
          menuFlag: false,
        }
      }
    ]
  },
  // 专业技能
  {
    path: '/professionalSkill',
    component: () => import('@/views/professionalSkill.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      topNavFlag: true,
      // backBtn: true,
      menuFlag: true,
    },
    children: [
      // 视频课程
      {
        name: 'professionalSkill-videoList',
        path: 'videoList',
        component: () => import('@/components/videoList.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 视频观看记录
      {
        name: 'professionalSkill-videoRecordList',
        path: 'videoRecordList',
        component: () => import('@/components/videoWatchRecord.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 课程课件
      {
        name: 'professionalSkill-courseWare',
        path: 'courseWare',
        component: () => import('@/components/courseWare.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 相关资料
      {
        name: 'professionalSkill-relateData',
        path: 'relateData',
        component: () => import('@/components/relateData.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      {
        name: 'professionalSkill-videoBox',
        path: 'videoBox',
        component: () => import('@/components/videoPublic.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          topNavFlag: false,
          backBtn: false,
          menuFlag: false,
        }
      }
    ]
  },
  // 营销技能
  {
    path: '/marketSkill',
    component: () => import('@/views/marketSkill.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      topNavFlag: true,
      // backBtn: true,
      menuFlag: true,
    },
    children: [
      // 视频课程
      {
        name: 'marketSkill-videoList',
        path: 'videoList',
        component: () => import('@/components/videoList.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 视频观看记录
      {
        name: 'marketSkill-videoRecordList',
        path: 'videoRecordList',
        component: () => import('@/components/videoWatchRecord.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 课程课件
      {
        name: 'marketSkill-courseWare',
        path: 'courseWare',
        component: () => import('@/components/courseWare.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 相关资料
      {
        name: 'marketSkill-relateData',
        path: 'relateData',
        component: () => import('@/components/relateData.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      {
        name: 'marketSkill-videoBox',
        path: 'videoBox',
        component: () => import('@/components/videoPublic.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          topNavFlag: false,
          backBtn: false,
          menuFlag: false,
        }
      }
    ]
  },
  // 通用技能
  {
    path: '/generalSkill',
    component: () => import('@/views/generalSkill.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      topNavFlag: true,
      // backBtn: true,
      menuFlag: true,
    },
    children: [
      // 视频课程
      {
        name: 'generalSkill-videoList',
        path: 'videoList',
        component: () => import('@/components/videoList.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 视频观看记录
      {
        name: 'generalSkill-videoRecordList',
        path: 'videoRecordList',
        component: () => import('@/components/videoWatchRecord.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 课程课件
      {
        name: 'generalSkill-courseWare',
        path: 'courseWare',
        component: () => import('@/components/courseWare.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      // 相关资料
      {
        name: 'generalSkill-relateData',
        path: 'relateData',
        component: () => import('@/components/relateData.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          topNavFlag: true,
          backBtn: true,
          menuFlag: true,
        }
      },
      {
        name: 'generalSkill-videoBox',
        path: 'videoBox',
        component: () => import('@/components/videoPublic.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          topNavFlag: false,
          backBtn: false,
          menuFlag: false,
        }
      }
    ]
  },
  // 优秀学师
  {
    path: '/teacher',
    component: () => import('@/views/teacher.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    },
    children: [
      {
        name: 'craftsPerson',
        path: 'craftsPerson',
        component: () => import('@/components/teacher/craftsPerson.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showTopNav: true,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: 'personDetail',
        path: 'personDetail',
        component: () => import('@/components/teacher/personDetail.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showTopNav: false,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: 'addPersonData',
        path: 'addPersonData',
        component: () => import('@/components/teacher/addPersonData.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showTopNav: false,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: 'unrecordPerson',
        path: 'unrecordPerson',
        component: () => import('@/components/teacher/unrecordPerson.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showTopNav: false,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: 'teacherList',
        path: 'teacherList',
        component: () => import('@/components/teacher/teacherList.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showTopNav: true,
          backBtn: true,
          menuFlag: true,
        },
      },
    ]
  },
  //行业专家
  {
    path: '/industryExpert',
    component: () => import('@/views/industryExpert.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      menuFlag: true,
    },
    children: [
      {
        path: 'speciaList',
        component: () => import('@/components/industryExpert/speciaList.vue'),
        meta: {
          requireAuth: true,
          keepAlive: true,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },

      },{
        name:'details',
        path: 'details',
        component: () => import('@/components/industryExpert/details.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },

      },
    ]
  },
  // 直播
  {
    path: '/live',
    component: () => import('@/views/live.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      menuFlag: true,
    },
    children: [
      {
        path: 'watchLive',
        component: () => import('@/components/live/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },

      },
      {
        path: 'studyRecord',
        component: () => import('@/components/live/liveWatchRecord.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },

      },
    ]
  },
  // 黑库
  {
    path: '/blackLibrary',
    component: () => import('@/views/blackLibrary.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    },
    children: [
      {
        path: 'creditBlacklist',
        component: () => import('@/components/black/creditBlacklist.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },

      },
      {
        path: 'personalInformation',
        component: () => import('@/components/black/personalInformation.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },

      }
    ]
  },
  // 服务
  {
    path: '/serve',
    component: () => import('@/views/serve.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      showNav: true,
      backBtn: true,
      menuFlag: true,
    },
    children: [
      {
        name: '行业发展报告',
        path: 'industryReport',
        component: () => import('@/components/serve/industryReport/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showNav: true,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: '团队列表',
        path: 'teamList',
        component: () => import('@/components/serve/team/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showNav: true,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: '团队详情',
        path: 'teamDetail',
        component: () => import('@/components/serve/team/teamDetail.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showNav: false,
          backBtn: true,
          menuFlag: true,
        },
      },
      // 培训展示
      {
        path: 'trainShow',
        component: () => import('@/components/serve/trainShow/trainShow.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showNav: true,
          backBtn: true,
          menuFlag: true,
        },
        children: [
          {
            path: 'courseReview',
            name: '课程回顾',
            component: () => import('@/components/serve/trainShow/courseReview.vue'),
            meta: {
              requireAuth: true,
              keepAlive: false,
              title: '人才学院',
              showNav: true,
              backBtn: true,
              menuFlag: true,
            },
          },
          {
            path: 'reviewDetail',
            name: '课程回顾详情',
            component: () => import('@/components/serve/trainShow/reviewDetail.vue'),
            meta: {
              requireAuth: true,
              keepAlive: false,
              title: '人才学院',
              showNav: false,
              backBtn: true,
              menuFlag: true,
            },
          },
          {
            path: 'noticeRecord',
            name: '通知记录',
            component: () => import('@/components/serve/trainShow/noticeRecord.vue'),
            meta: {
              requireAuth: true,
              keepAlive: false,
              title: '人才学院',
              showNav: true,
              backBtn: true,
              menuFlag: true,
            },
          },
          {
            path: 'trainProject',
            name: '培训项目',
            component: () => import('@/components/serve/trainShow/trainProject.vue'),
            meta: {
              requireAuth: true,
              keepAlive: false,
              title: '人才学院',
              showNav: true,
              backBtn: true,
              menuFlag: true,
            },
            children: [
              {
                path: 'trainProjectList',
                name: '列表',
                component: () => import('@/components/serve/trainShow/trainProjectList.vue'),
                meta: {
                  requireAuth: true,
                  keepAlive: false,
                  title: '人才学院',
                  showNav: true,
                  backBtn: true,
                  menuFlag: true,
                },
              },
              {
                path: 'trainProjectDetail',
                name: '培训项目详情',
                component: () => import('@/components/serve/trainShow/trainProjectDetail.vue'),
                meta: {
                  requireAuth: true,
                  keepAlive: false,
                  title: '人才学院',
                  showNav: true,
                  backBtn: true,
                  menuFlag: true,
                },
              },
              {
                path: 'trainStudent',
                name: '参训学员',
                component: () => import('@/components/serve/trainShow/trainStudent.vue'),
                meta: {
                  requireAuth: true,
                  keepAlive: false,
                  title: '人才学院',
                  showNav: true,
                  backBtn: true,
                  menuFlag: true,
                },
              },
            ]
          },
        ]
      },
      {
        path: 'officeMap',
        name: '办公室分布图',
        component: () => import('@/components/serve/officeMap/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showNav: true,
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        path: 'talentRecruitment',
        name: '人才招聘',
        component: () => import('@/components/serve/talentRecruitment/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          showNav: true,
          backBtn: true,
          menuFlag: true,
        },
      }
    ]
  },
  // 人事任命
  {
    path: '/appointmentLetter',
    component: () => import('@/views/appointmentLetter.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    },
    children: [
      {
        name: 'appointmentLetterList',
        path: 'appointmentLetterList',
        component: () => import('@/components/appointmentLetter/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },
      },
      {
        name: 'appointmentLetterDetail',
        path: 'detail',
        component: () => import('@/components/appointmentLetter/detail.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },
      }
    ]
  },
  // 数字化月报
  {
    path: '/digitalReport',
    component: () => import('@/views/digitalReport.vue'),
    redirect: '/digitalReport/current',
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    },
    children: [
      {
        name: 'digitalReportCurrent',
        path: 'current',
        component: () => import('@/components/digitalReport/currentReport/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
          minRank: 5,
        },
      },
      {
        name: 'digitalReportHistory',
        path: 'history',
        component: () => import('@/components/digitalReport/historyReport/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
          minRank: 5,
        },
      },
      {
        name: 'digitalReportPlaza',
        path: 'plaza',
        component: () => import('@/components/digitalReport/learningPlaza/index.vue'),
        meta: {
          requireAuth: true,
          keepAlive: false,
          title: '人才学院',
          backBtn: true,
          menuFlag: true,
        },
      },
    ],
  },
  // 查看pdf
  {
    name: 'vPdf',
    path: '/vPdf',
    component: () => import('@/components/vPdf.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    }
  },
  // 地图测试
  {
    name: 'bMap',
    path: '/bMap',
    component: () => import('@/components/mapTest.vue'),
    meta: {
      requireAuth: true,
      keepAlive: false,
      title: '人才学院',
      backBtn: true,
      menuFlag: true,
    }
  },
  {
    path: '*',
    redirect: (to) => {
      const mobileTarget = mapPcPathToMobile(to.path, to.query);
      return {
        path: mobileTarget.path === to.path ? '/home' : mobileTarget.path,
        query: mobileTarget.query,
      }
    },
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

function getcookie(objname) {//获取指定名称的cookie的值
  var match = document.cookie.match(new RegExp("(^| )" + objname + "=([^;]*)(;|$)"));
  return match ? unescape(match[2]) : null;
}
let currentUserInfo = null
let currentUserPromise = null

function parseRankNumber(rank) {
  const match = String(rank || "").toUpperCase().match(/M\s*(\d+)/)
  return match ? Number(match[1]) : -1
}

function getRouteMinRank(route) {
  return route.matched.reduce((rank, record) => {
    const minRank = record.meta && record.meta.minRank
    return minRank ? Math.max(rank, minRank) : rank
  }, 0)
}

function getCurrentUserInfo() {
  if (currentUserInfo) return Promise.resolve(currentUserInfo)
  if (!currentUserPromise) {
    currentUserPromise = queryCurrentUser().then((res) => {
      currentUserPromise = null
      const data = res && res.data ? res.data : res
      if (data.code == "0" && data.resultObj) {
        currentUserInfo = data.resultObj
        Vue.prototype.$cookies.set("roles", JSON.stringify(currentUserInfo.roles || []))
        return currentUserInfo
      }
      return null
    }).catch(() => {
      currentUserPromise = null
      return null
    })
  }
  return currentUserPromise
}

async function hasRoutePermission(route) {
  const minRank = getRouteMinRank(route)
  if (!minRank) return true
  const userInfo = await getCurrentUserInfo()
  return parseRankNumber(userInfo && userInfo.rank) >= minRank
}

function goRouteByPermission(to, next) {
  hasRoutePermission(to).then((allowed) => {
    if (allowed) {
      next()
    } else {
      next({
        path: "/digitalReport/plaza",
        replace: true,
      })
    }
  })
}
var pcUrl='https://talent-pc.zhongkewei.com/#'
// 跳转验证
router.beforeEach((to, from, next) => {
  var { userid, token } = to.query;
  var { path } = to;
  const ua = navigator.userAgent.toLowerCase();
  var isMobile = /mobile|android|iphone|ipod|phone|ipad/i.test(ua);

  // 兼容从 PC 端复制或切换过来的地址，先转换成移动端路由再进入鉴权。
  if (isMobile) {
    const mobileTarget = mapPcPathToMobile(path, to.query);
    if (mobileTarget.path !== path) {
      next({
        path: mobileTarget.path,
        query: mobileTarget.query,
        replace: true,
      });
      return;
    }
  }

  if (to.meta.requireAuth) {
    // 判断是否需要登录权限
    if (getcookie("userid") && getcookie("token")&& getcookie("kmsToken")) {
      if (isMobile) {
        goRouteByPermission(to, next);
      } else {
        const pcTarget = mapMobilePathToPc(path, to.query);
        window.location.href = buildExternalRouteUrl(pcUrl, pcTarget, {
          userid: getcookie("userid"),
          token: getcookie("token"),
        });
      }
    } else if (userid && token) {
      login1({ userid, token })
        .then((res) => {
          const data = res && res.data ? res.data : res;
          if (data.code != "0") {
            if (isMobile) {
              next({ path: "/login", replace: true });
            } else {
              window.location.href = `${pcUrl}/login`;
            }
            return;
          }

          const sessionToken = data.resultObj || token;
          Vue.prototype.$cookies.set("userid", userid);
          Vue.prototype.$cookies.set("token", sessionToken, 60 * 60 * 12);
          Vue.prototype.$cookies.set("kmsToken", sessionToken, 60 * 60 * 12);
          currentUserInfo = null

          if (isMobile) {
            hasRoutePermission(to).then((allowed) => {
              if (allowed) {
                next();
              } else {
                next({
                  path: "/digitalReport/plaza",
                  replace: true,
                });
              }
            })
          } else {
            const pcTarget = mapMobilePathToPc(path, to.query);
            window.location.href = buildExternalRouteUrl(pcUrl, pcTarget, {
              userid,
              token: sessionToken,
            });
          }
        })
        .catch(() => {
          if (isMobile) {
            next({ path: "/login", replace: true });
          } else {
            window.location.href = `${pcUrl}/login`;
          }
        });
    } else {
      // 没登录则跳转到登录界面
      if (isMobile) {
        next({
          path: "/login",
          query: {
            redirect: to.fullPath,
            date: new Date().getTime(),
          },
        });
      } else {
        window.location.href = `${pcUrl}/login`;
      }
    }
  } else {
    if (isMobile) {
      next();
    } else {
      if (userid && token) {
        const pcTarget = mapMobilePathToPc(path, to.query);
        window.location.href = buildExternalRouteUrl(pcUrl, pcTarget);
      } else {
        window.location.href = `${pcUrl}/index`;
      }
    }
  }
})

router.afterEach(function (to) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
});
export default router
